import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, inject, OnInit, signal, ViewEncapsulation, WritableSignal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslocoService } from '@ngneat/transloco';
import { CreateNoonReportComponent } from '@vessel-reports/noon/components/create-noon-report/create-noon-report.component';
import { NoonReportDetailsComponent } from '@vessel-reports/noon/components/noon-report-details/noon-report-details.component';
import { NoonReportType } from '@vessel-reports/noon/state/noon.types';

@Component({
  selector: 'noon-report-dialog',
  imports: [CreateNoonReportComponent, NoonReportDetailsComponent],
  templateUrl: './noon-report-dialog.component.html',
  styleUrl: './noon-report-dialog.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NoonReportDialogComponent implements OnInit {
  protected readonly translocoService: TranslocoService = inject(TranslocoService);

  type: WritableSignal<NoonReportType> = signal('create-new');

  constructor(
    private _matDialogRef: MatDialogRef<NoonReportDialogComponent>,
    private _changeDetector: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    if (this.data?.type === 'details') {
      this.type.set('details');
    }
  }

  onSaveCreate() {
    this.type.set('details');
  }

  onClose() {
    this._matDialogRef.close();
  }
}
